// ** React Imports
import { Fragment, useState, useEffect } from 'react';

// ** Components
import { columns } from './Columns';
import Header from './Header';
import ComponentSpinner from '../../../@core/components/spinner/Loading-spinner';

// ** Graphql
import { GetRankingRoads } from '../../../graphql/Mutation/ranking';
import { useMutation } from '@apollo/client';

// ** Third Party Components
import ReactPaginate from 'react-paginate';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import Filters from './Filters';

// ** Icons Imports
import { ChevronDown } from 'react-feather';

// ** Reactstrap Imports
import { Card, Row, Col } from 'reactstrap';

// ** Styles
import '@styles/react/libs/react-select/_react-select.scss';
import '@styles/react/libs/tables/react-dataTable-component.scss';
// import moment from 'moment';

const Table = () => {
  const [getList] = useMutation(GetRankingRoads);
  const [store, setStore] = useState([]);
  // ** States
  const [sort, setSort] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortColumn, setSortColumn] = useState('id');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [picker, setPicker] = useState([]);
  const [totalPillars, setTotalPillars] = useState({
    emotions: 0,
    purpose: 0,
    relations: 0,
    selfEsteem: 0,
    transformation: 0
  });
  const [currentPillar, setCurrentPillar] = useState({
    value: 'EMPTY',
    label: 'Seleccionar Pilar'
  });

  const handleFetching = async ({
    _sort,
    _sortColumn,
    _page,
    _q,
    _perPage,
    _pillar,
    _dates
  }) => {
    try {
      const {
        data: { getRankingRoads: data }
      } = await getList({
        variables: {
          input: {
            sort: _sort,
            sortColumn: _sortColumn,
            q: _q,
            perPage: _perPage,
            page: _page,
            pillar: _pillar,
            dates: _dates || picker
          }
        }
      });
      setStore(() => {
        setCurrentPage(() => data.page);
        setRowsPerPage(() => data.limit);
        setTotalPages(() => data.totalPages);
        setTotalPillars(() => data.totalPillars);
        return data.docs;
      });
    } catch (e) {}
  };

  function convertArrayOfObjectsToXLSX(array) {
    const translate = [
      {
        key: 'ranking',
        name: ['Ranking']
      },
      {
        key: 'cover',
        name: ['Portada']
      },
      {
        key: 'name',
        name: ['Nombre']
      },
      {
        key: 'episodes',
        name: ['Episodios'],
        episodeFormat: true
      },
      {
        key: 'likes',
        name: ['Me gusta']
      },
      {
        key: 'started',
        name: ['Empezado']
      },
      {
        key: 'finished',
        name: ['Completado']
      },
      {
        key: 'membership',
        name: ['Membresia']
      },
      {
        key: 'status',
        name: ['Estado'],
        statusFormat: true
      }
    ];

    const keys = [
      'ranking',
      'cover',
      'name',
      'episodes',
      'likes',
      'started',
      'finished',
      'membership',
      'status'
    ];

    const _data = new Map();

    translate.forEach(({ key, ...rest }) => _data.set(key, rest));

    const result = [];

    let firstRow = [];
    [..._data.values()].forEach(
      (item) => (firstRow = [...firstRow, ...item.name])
    );
    result.push(firstRow);

    array.forEach((item, idx) => {
      let temp = [idx + 1];
      keys.forEach((key) => {
        const _item = _data.get(key);
        if (_item) {
          if (_item.episodeFormat) {
            temp = [...temp, item[key].length];
          } else {
            const exists = item[key];
            if (exists || exists === 0) {
              if (_item.statusFormat) {
                temp = [...temp, item[key] ? 'Activo' : 'Inactivo'];
              } else {
                temp = [...temp, item[key]];
              }
            }
          }
        }
      });
      result.push(temp);
    });

    return result;
  }

  // ** Downloads CSV
  function downloadCSV(array) {
    const anchor = document.createElement('a');
    const data = convertArrayOfObjectsToXLSX(array);
    if (data === null) return;

    const filename = 'subliful_all_ranking_caminos.xlsx';

    const workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(data);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    const xlsbin = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'binary'
    });

    const buffer = new ArrayBuffer(xlsbin.length),
      array2 = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array2[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    const xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(xlsblob);

    anchor.href = url;
    anchor.download = filename;
    anchor.click();
  }

  const handleDownload = async () => {
    try {
      const {
        data: { getRankingRoads: data }
      } = await getList({
        variables: {
          input: {
            sort: '',
            sortColumn: '',
            q: '',
            perPage: 10,
            page: 1,
            pillar: 'EMPTY',
            dates: [],
            all: true
          }
        }
      });
      downloadCSV(data.docs);
    } catch (e) {}
  };

  // ** Get data on mount
  useEffect(() => {
    handleFetching({
      _sort: sort,
      _sortColumn: sortColumn,
      _page: currentPage,
      _q: searchTerm,
      _perPage: rowsPerPage,
      _pillar: currentPillar.value,
      _dates: picker
    });
  }, []);

  // ** Function in get data on page change
  const handlePagination = (page) => {
    handleFetching({
      _sort: sort,
      _sortColumn: sortColumn,
      _page: page.selected + 1,
      _q: searchTerm,
      _perPage: rowsPerPage,
      _pillar: currentPillar.value,
      _dates: picker
    });
    setCurrentPage(page.selected + 1);
  };

  // ** Function in get data on rows per page
  const handlePerPage = (e) => {
    const value = parseInt(e.currentTarget.value);

    handleFetching({
      _sort: sort,
      _sortColumn: sortColumn,
      _page: 1,
      _q: searchTerm,
      _perPage: value,
      _pillar: currentPillar.value,
      _dates: picker
    });
    setRowsPerPage(value);
  };

  // ** Function in get data on search query change
  const handleFilter = (val) => {
    setSearchTerm(() => {
      handleFetching({
        _sort: sort,
        _sortColumn: sortColumn,
        _page: 1,
        _q: val,
        _perPage: rowsPerPage,
        _pillar: currentPillar.value,
        _dates: picker
      });
      return val;
    });
  };

  const handleFilterDates = () => {
    handleFetching({
      _sort: sort,
      _sortColumn: sortColumn,
      _page: 1,
      _q: searchTerm,
      _perPage: rowsPerPage,
      _pillar: currentPillar.value,
      _dates: picker
    });
  };

  // ** Table data to render
  const dataToRender = () => {
    const filters = {
      q: searchTerm
    };

    const isFiltered = Object.keys(filters).some(function (k) {
      return filters[k].length > 0;
    });

    if (store.length > 0) {
      return store;
    } else if (store.length === 0 && isFiltered) {
      return [];
    }
  };

  const handleSort = (column, sortDirection) => {
    setSort(sortDirection);
    setSortColumn(column.sortField);
  };

  const NoDataRecords = () => {
    return (
      <Row>
        <Col md={12} className="text-align-center mt-4 mb-4">
          No hay registros que mostrar
        </Col>
      </Row>
    );
  };

  const CustomPagination = () => {
    return (
      <ReactPaginate
        previousLabel={''}
        nextLabel={''}
        pageCount={totalPages || 1}
        activeClassName="active"
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        containerClassName={
          'pagination react-paginate justify-content-end my-2 pe-1'
        }
      />
    );
  };

  return (
    <Fragment>
      <Filters
        handleFetching={handleFetching}
        sort={sort}
        sortColumn={sortColumn}
        searchTerm={searchTerm}
        rowsPerPage={rowsPerPage}
        currentPillar={currentPillar}
        setCurrentPillar={setCurrentPillar}
        totalPillars={totalPillars}
      />

      <Card className="overflow-hidden">
        <div className="react-dataTable">
          <DataTable
            noHeader
            subHeader
            sortServer
            pagination
            responsive
            paginationServer
            noDataComponent={<NoDataRecords />}
            progressComponent={<ComponentSpinner />}
            columns={columns}
            onSort={handleSort}
            sortIcon={<ChevronDown />}
            className="react-dataTable"
            paginationComponent={CustomPagination}
            data={dataToRender()}
            subHeaderComponent={
              <Header
                setPicker={setPicker}
                picker={picker}
                searchTerm={searchTerm}
                handleDownload={handleDownload}
                handleFilter={handleFilter}
                handleFilterDates={handleFilterDates}
                handlePerPage={handlePerPage}
              />
            }
          />
        </div>
      </Card>
    </Fragment>
  );
};

export default Table;
